import {
  Box,
  Button,
  Group,
  LoadingOverlay,
  Popover,
  Text,
  TextInput,
  Textarea,
} from "@mantine/core";
import { isNotEmpty, useForm } from "@mantine/form";
import { useDisclosure } from "@mantine/hooks";
import { modals } from "@mantine/modals";
import { IconCheck, IconX } from "@tabler/icons-react";
import { createConfigGroup } from "../../../api/ApiConfigGroup";
import { TblConfigGroup } from "../../../model/TblConfigGroup";
import { useState } from "react";

const CreateView = ({ onSearch }: any) => {
  const entity = {
    id: 0,
    name: "",
    description: "",
    searchFulltext: "",
    configGroupType: "",
  };

  const handleCreateConfigGroup = async (dataSubmit: TblConfigGroup) => {
    open();
    await createConfigGroup(dataSubmit);
    onSearch();
    close();
    modals.closeAll();
  };

  const [visible, { toggle, close, open }] = useDisclosure(false);
  const [popoverOpened, setPopoverOpened] = useState(false);
  const form = useForm<TblConfigGroup>({
    initialValues: {
      ...entity,
    },
    validate: {
      name: isNotEmpty("Tên nhóm chưa chưa nhập"),
    },
  });

  return (
    <>
      <Box
        className="flex-none"
        component="form"
        miw={950}
        maw={950}
        mx="auto"
        onSubmit={form.onSubmit((e: TblConfigGroup) => {
          handleCreateConfigGroup(e);
        })}
      >
        <LoadingOverlay
          visible={visible}
          zIndex={1000}
          overlayProps={{ radius: "sm", blur: 2 }}
        />
        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <TextInput
            label={"Tên nhóm"}
            placeholder={"Nhập tên nhóm"}
            withAsterisk
            mt="md"
            type="text"
            {...form.getInputProps("name")}
          />
        </Group>

        <Group grow wrap="nowrap" mt="lg" gap={"lg"}>
          <Textarea
            label={"Mô tả tóm tắt"}
            placeholder={"Nhập mô tả"}
            mt="md"
            {...form.getInputProps("description")}
          />
        </Group>

        <Group
          justify="center"
          mt="xs"
          p="5px 0"
          style={{
            position: "sticky",
            bottom: 0,
            backgroundColor: "white",
          }}
        >
          <Button
            type="submit"
            color="#3598dc"
            loading={visible}
            leftSection={<IconCheck size={18} />}
          >
            Lưu
          </Button>
          <Popover
            width={300}
            position="top"
            withArrow
            shadow="md"
            opened={popoverOpened}
            onChange={setPopoverOpened}
          >
            <Popover.Target>
              <Button
                color="red"
                style={{ marginLeft: 10 }}
                onClick={() => setPopoverOpened(true)}
                leftSection={<IconX size={18} />}
              >
                Đóng
              </Button>
            </Popover.Target>
            <Popover.Dropdown>
              <Text>Bạn có chắc chắn muốn đóng không?</Text>
              <Group grow mt="lg">
                <Button
                  color="red"
                  leftSection={<IconCheck size={18} />}
                  onClick={() => {
                    modals.closeAll();
                  }}
                >
                  Đóng
                </Button>
                <Button
                  variant="outline"
                  color="gray"
                  leftSection={<IconX size={18} />}
                  onClick={() => setPopoverOpened(false)}
                >
                  Hủy
                </Button>
              </Group>
            </Popover.Dropdown>
          </Popover>
        </Group>
      </Box>
    </>
  );
};

export default CreateView;
